import React from 'react'
// NAVIGATION
import { useNavigate, Link } from 'react-router-dom'

// IMAGES
import imageCalendar from '../../../images/calendargif.gif'
import imagePush from '../../../images/imagepush.png'
import imagePhone from '../../../images/phone.png'
import imageChat from '../../../images/chat.png'
import imageChatGif from '../../../images/chatgif.gif'
import imageInfo from '../../../images/info.png'

const ViewClient = ({ state, _booking, uid, messagesChat }) => {
    let navigate = useNavigate()

    return ( 
        <>
            {/* AFFICHAGE BOUTONS PANNING / CLIENTS */} 
            <div className='row text-center mt-4'> 

                {/* RESERVER */}
                <div className='col-6'  >
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginLeft:-3}}>
                        <div className='text-center' onClick={() => _booking(uid)}> 
                            <Link 
                                to='/clientBooking' 
                                className='text-decoration-none'
                                style={{ color:'black' }} 
                                state={{ uidClient:uid, nameClient:state.nameClient, surnameClient:state.surnameClient, emailClient:state.emailClient }}
                            >
                                <img src={imageCalendar} className='img-fluid' alt='image reserver' style={{ height:50, width:50 }} />
                                <div className='text-center' style={{fontSize:12}}>RÉSERVER</div>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* PUSH */}
                <div className='col-6' data-bs-toggle="modal" data-bs-target="#modalInfoClient">
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginRight:-3}}>
                        <div className='text-center'>
                            <img src={imageInfo} className='img-fluid' alt='informations' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>INFORMATIONS</div>
                        </div>
                    </div>
                </div>

            </div>
 
            {/* PHONE */} 
            <div className='row text-center mt-4'>

                {/* PUSH */}
                <div className='col-4' data-bs-toggle="modal" data-bs-target="#modalSendPushClient">
                    <div className='bg-white shadow rounded-2 py-3' >
                        <div className='text-center'>
                            <img src={imagePush} className='img-fluid' alt='image message Push' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>MESSAGE PUSH</div>
                        </div>
                    </div>
                </div> 

                {/* CHAT */}
                <div className='col-4' /*onClick={() => navigate('/chat')}*/ >
                    <div className='bg-white shadow rounded-2 py-3' >
                        <Link  to='/chatSingle' className='text-decoration-none text-center' state={{ uidClient:uid, nameClient:state.nameClient, surnameClient:state.surnameClient }} >
                            {/* TEST IS NEW CHAT*/}
                            {messagesChat
                                .filter(mes => mes.receiver === 'client' && mes.isNew)
                                .map(mes => mes.id).length != 0 ? 
                                <img src={imageChatGif} className='img-fluid' alt='image message' style={{ height:50, width:50 }} />
                            : 
                                <img src={imageChat} className='img-fluid' alt='image message' style={{ height:50, width:50 }} />
                            }
                            <div className='text-center text-dark' style={{fontSize:12, textDecoration:'none', color: '#FFFFFF' }}>CHAT</div>
                        </Link> 
                    </div>
                </div>

                {/* BUTTON APPELER */}
                <div className='col-4' onClick={() => navigate('/phoneUsersPage')}>
                    <div className='bg-white shadow rounded-2 py-3' >
                        <div className='text-center'>
                            <img src={imagePhone} className='img-fluid' alt='image phone' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>APPELER</div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default ViewClient